import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-moving-party-form',
  templateUrl: './moving-party-form.component.html',
  styleUrls: ['./moving-party-form.component.scss']
})
export class MovingPartyFormComponent implements OnInit {
  movingPartyForm: FormGroup;
  @Output() hasValidMovingParty = new EventEmitter<boolean>();
  @Output() data = new EventEmitter();
  constructor(private _formBuilder: FormBuilder) { }


  ngOnInit(): void {
    this.movingPartyForm = this._formBuilder.group({
      isMoving: [null]
    });

    this.hasValidMovingParty.emit(this.movingPartyForm.valid);
    this.movingPartyForm.statusChanges.subscribe((res) => {
      this.hasValidMovingParty.emit(this.movingPartyForm.valid);
    });
    this.movingPartyForm.valueChanges.subscribe(res => {
      this.data.emit(res);
    })
  }
}
